const normalizeFilenames = (input) => {
    let filenames = [];

    if (Array.isArray(input)) {
        // Input is already an array
        filenames = input;
    } else if (typeof input === 'string') {
        // Remove surrounding { } if present
        let cleaned = input.replace(/[{}]/g, '');

        // Split by comma
        filenames = cleaned
            .split(',')
            .map((p) => p.trim().replace(/^["']|["']$/g, ''));
    } else {
        return input;
    }

    return filenames;
};

export const displayFilenames = (input) => {
    return normalizeFilenames(input).join(', ');
};
